export default __webpack_public_path__ + "locales/nl/Payments.json?hash=e9c7ce09c62a1b72928906502649e20f";